import {cs}             from "@Common/react/chain-services";
import {provideContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {Static2}        from "@Common/react/static-2";

import {createListingsApis} from "./listings/listings-apis";
import {createNextApis}     from "./next/next-apis";

export const loadLiveApis = ({next, onUnauthorized}) => cs(
    ["listingDomain", ({}, next) => {
        // sessionStorage.LISTING_API_HOST = "http://10.101.202.12:3030"
        const host = sessionStorage.LISTING_API_HOST || localStorage.LISTING_API_HOST;
        if (host) {
            return next(host);
        }
        return Load({
            fetch: async () => {
                const res = await fetch("/next-api/apm2Listings/url");
                try {
                    const result = await res.json();
                    // return result.url ? result.url : "not found";

                    return result.url?.replace(/\/$/,"");
                } catch (e) {
                    // return 'not found';
                    return null;
                }
            },
            next,
        });
    }],
    ["nextApis", (_, next) => Static2({next, getInitValue: () => createNextApis({onUnauthorized})})],
    ["apis", ({listingDomain, nextApis}, next) => next({
        next: nextApis.get(),
        listings: listingDomain && {
            ...createListingsApis({
                domain: listingDomain,
                fetcher: createLiveListingFetcher({listingDomain}),
            }),
            domain: listingDomain,
        }
    })],

    ({apis}) => provideContext({apis}, next),
);

const createLiveListingFetcher = ({listingDomain}) => ({
    getJson: async (url, returnJson=true) => {
        return await fetch(
            listingDomain + url,
            {
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then(res => returnJson ? res.json() : res)
    },
    postJson: async (url, data, returnJson=true) => {
        return await fetch(
            listingDomain + url,
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: data && JSON.stringify(data),
            }
        ).then(res => returnJson ? res.json() : res)
    },
});

